import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    TextField as InputField,
    DialogTitle, FormControl,
    InputLabel, MenuItem, Select,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
    List,
    Datagrid,
    TextField,
    TopToolbar,
    FunctionField,
    DateField,
    Button,
    useDataProvider,
    useListContext,
    useRefresh,
    useNotify,
    ShowButton,
    FileInput,
    FileField,
} from "react-admin";
import { apiUrl } from "../../Services/config";

const STATUS_CHOICES = [
    { id: 1, name: "审核中" },
    { id: 2, name: "打款中" },
    { id: 3, name: "提现异常" },
    { id: 4, name: "已结清" }
];

// 状态流转配置
const STATUS_FLOW = {
    1: [2, 3, 4], // 审核中 -> 打款中, 提现异常, 已结清
    2: [3, 4],    // 打款中 -> 提现异常, 已结清
    3: [2, 4],    // 提现异常 -> 打款中, 已结清
    4: []         // 已结清 -> 无后续状态
};


const ListActions = () => {
    const { setFilters, filterValues, total } = useListContext();  // 获取列表上下文，添加total
    const initialFilters = {};  // 初始过滤器值
    const dataProvider = useDataProvider(); // 获取数据提供者
    const notify = useNotify(); // 获取通知方法

    // // 重置过滤器函数
    // const handleResetFilters = () => {
    //     setFilters(initialFilters);
    // };

    const exportDetails = (id?: any) => {
        if (window.confirm(`确认导出提现列表？`)) {
            const formData = {
                ...filterValues,
            };
            dataProvider.withdrawExport(formData)
                .then(() => {
                    notify('导出提现列表成功', { type: 'success' });
                })
                .catch((error: any) => {
                    notify(error.message || '导出提现列表失败', { type: 'error' });
                })
        }
    }

    // 如果没有数据，不显示任何按钮
    if (total === 0) {
        return null;
    }

    return (
        <TopToolbar>
            {/* <Button
                label="重置搜索"
                onClick={handleResetFilters}
                disabled={Object.keys(filterValues).length === 0}  // 当没有过滤条件时禁用
            /> */}
            <Button
                label="导出"
                onClick={exportDetails}
            />
        </TopToolbar>
    );
};



export const withdrawalList = () => {
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [currentRecord, setCurrentRecord] = useState(null);
    const dataProvider = useDataProvider(); // 获取数据提供者
    const notify = useNotify(); // 获取通知方法

    const handleEditRecord = (record: any) => {
        setCurrentRecord(record);
        setEditDialogOpen(true);
    };



    // 关闭编辑对话框
    const handleCloseEditDialog = () => {
        setEditDialogOpen(false);
        setCurrentRecord(null);
    };



    const exportDetails = (id?: any) => {
        if (window.confirm(`确认导出提现列表？`)) {
            dataProvider.withdrawExport({ id })
                .then(() => {
                    notify('导出提现列表成功', { type: 'success' });
                })
                .catch((error: any) => {
                    notify(error.message || '导出提现列表失败', { type: 'error' });
                })
        }
    }

    return (
        <>
            <List actions={<ListActions />} empty={false}>
                <Datagrid bulkActionButtons={false} rowClick={false} sx={{
                    '& .RaDatagrid-tableWrapper': {
                        tableLayout: 'auto',
                    },
                    '& .MuiTableCell-root': {
                        overflow: 'visible',
                    }
                }}>
                    <TextField source="id" label="ID" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />
                    <TextField source="salesCustomerName" label="销售客户" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />
                    <TextField source="reconciliationMonth" label="对账月份" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />
                    <TextField source="amount" label="提现金额" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />

                    {/* 状态字段 - 使用选择器显示友好名称 */}
                    <FunctionField
                        source="status"
                        label="状态"
                        render={(record) => {
                            const status = STATUS_CHOICES.find(choice => choice.id === record.status);
                            return status ? status.name : record.status;
                        }}
                        sortable={false}
                    />

                    <DateField source="createTime" label="申请日期" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />
                    <DateField source="transferDate" label="完成日期" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />
                    <TextField source="withdrawalNo" label="流水号" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />
                    <TextField source="remark" label="备注" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />

                    <FunctionField
                        label="操作"
                        render={(record) => {
                            // 获取可用的状态选项
                            const availableStatusIds = STATUS_FLOW[record.status] || [];
                            const isDisabled = availableStatusIds.length === 0;

                            return (
                                <Box sx={{ justifyContent: 'center', display: 'flex', gap: '8px' }}>
                                    <Button
                                        label="编辑"
                                        onClick={() => handleEditRecord(record)}
                                        disabled={isDisabled}
                                    />
                                    <Button
                                        label="导出"
                                        onClick={() => exportDetails(record.id)}
                                    />
                                    <ShowButton
                                        label="详情"
                                        record={{ id: record.id }}
                                    />
                                </Box>
                            );
                        }}
                    />
                </Datagrid>
            </List>
            <EditDialog
                open={editDialogOpen}
                onClose={handleCloseEditDialog}
                record={currentRecord}
            />
        </>
    )
};


// 编辑对话框组件
const EditDialog = ({ open, onClose, record }) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const [uploading, setUploading] = useState(false);
    const [previewImageUrl, setPreviewImageUrl] = useState<string | null>(null);

    const [formData, setFormData] = useState({
        withdrawalIds: '',
        status: '',
        transferVoucher: '',
        remark: ''
    });

    const [originalData, setOriginalData] = useState({
        status: '',
        transferVoucher: '',
        remark: ''
    });

    const [previewOpen, setPreviewOpen] = useState(false);

    const handlePreview = async () => {
        if (!formData.transferVoucher) {
            notify('没有可预览的凭证', { type: 'warning' });
            return;
        }

        try {
            const token = localStorage.getItem('authToken');
            const url = getFileUrl(formData.transferVoucher);

            const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error('获取图片失败');
            }

            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);
            setPreviewImageUrl(blobUrl);
            setPreviewOpen(true);
        } catch (error) {
            console.error("预览图片失败:", error);
            notify('预览图片失败: ' + error.message, { type: 'error' });
        }
    };

    const handleClosePreview = () => {
        setPreviewOpen(false);
        if (previewImageUrl) {
            URL.revokeObjectURL(previewImageUrl);
            setPreviewImageUrl(null);
        }
    };

    useEffect(() => {
        if (record) {
            const initialData = {
                withdrawalIds: record.id || '',
                status: record.status || '',
                remark: record.remark || '',
                transferVoucher: record.transferVoucher || ''
            };
            setFormData(initialData);
            setOriginalData({
                status: record.status || '',
                transferVoucher: record.transferVoucher || '',
                remark: record.remark || ''
            });
        }
    }, [record]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // 检查状态和凭证是否有值且被修改过
    const shouldUpdateWithdrawal = () => {
        const statusChanged = formData.status !== originalData.status;
        const voucherChanged = formData.transferVoucher !== originalData.transferVoucher;

        // 只有当状态或凭证有变化，并且新值不为空时才返回true
        return (statusChanged && formData.status) ||
            (voucherChanged && formData.transferVoucher);
    };

    const handleSubmit = async () => {
        if (!record) return;

        try {
            const updatePromises = [];

            // 只有在状态和凭证有值且被修改过的情况下才调用 withdrawal 更新
            if (shouldUpdateWithdrawal()) {
                updatePromises.push(
                    dataProvider.update('withdrawal', {
                        id: record.id,
                        data: {
                            ...formData,
                        }
                    })
                );
            }

            // 备注更新单独处理，只有当备注发生变化时才更新
            if (formData.remark !== originalData.remark) {
                updatePromises.push(
                    dataProvider.updateRemark({
                        id: record.id,
                        remark: formData.remark
                    })
                );
            }

            // 如果有任何更新操作，执行它们
            if (updatePromises.length > 0) {
                await Promise.all(updatePromises);
                notify('提现更新成功', { type: 'success' });
            } else {
                notify('未检测到任何更改', { type: 'info' });
            }

            refresh();
            onClose();
        } catch (error: any) {
            console.error("提现更新失败:", error);
            notify('提现更新失败: ' + error.message, { type: 'error' });
        }
    };

    const getAvailableStatusChoices = () => {
        if (!record) return STATUS_CHOICES;

        const currentStatus = record.status;
        const availableStatusIds = STATUS_FLOW[currentStatus] || [];

        return STATUS_CHOICES.filter(choice =>
            availableStatusIds.includes(choice.id)
        );
    };

    const availableChoices = getAvailableStatusChoices();

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];
        if (!allowedTypes.includes(file.type)) {
            notify('请上传 JPG, PNG 或 PDF 格式的文件', { type: 'error' });
            return;
        }

        const maxSize = 5 * 1024 * 1024;
        if (file.size > maxSize) {
            notify('文件大小不能超过 5MB', { type: 'error' });
            return;
        }

        setUploading(true);

        try {
            const formDataToUpload = new FormData();
            formDataToUpload.append('file', file);

            const fileName = await dataProvider.fileAccount(formDataToUpload);

            if (fileName) {
                setFormData(prev => ({
                    ...prev,
                    transferVoucher: fileName.data
                }));
                notify('凭证上传成功', { type: 'success' });
            } else {
                throw new Error('上传失败，未返回文件名');
            }
        } catch (error) {
            console.error("文件上传失败:", error);
            notify('凭证上传失败: ' + (error.message || '未知错误'), { type: 'error' });
        } finally {
            setUploading(false);
            event.target.value = '';
        }
    };

    const getFileUrl = (fileName) => {
        if (!fileName) return null;
        return `${apiUrl}/files/file/${fileName}`;
    };

    return (
        <>
            <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
                <DialogTitle>编辑提现状态</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth margin="normal">
                        <InputLabel>状态</InputLabel>
                        <Select
                            name="status"
                            value={formData.status}
                            onChange={handleInputChange}
                            label="状态"
                            disabled={availableChoices.length === 0}
                        >
                            {availableChoices.map(choice => (
                                <MenuItem key={choice.id} value={choice.id}>
                                    {choice.name}
                                </MenuItem>
                            ))}
                            {availableChoices.length === 0 && (
                                <MenuItem value="" disabled>
                                    无可用状态选项
                                </MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                        <InputLabel shrink>
                            上传凭证
                        </InputLabel>
                        <Box>
                            <input
                                accept=".jpg,.jpeg,.png,.pdf"
                                style={{ display: 'none' }}
                                id="transfer-voucher-upload"
                                type="file"
                                onChange={handleFileUpload}
                                disabled={uploading}
                            />
                            <label htmlFor="transfer-voucher-upload">
                                <Button
                                    variant="outlined"
                                    component="span"
                                    disabled={uploading}
                                    fullWidth
                                >
                                    {uploading ? '上传中...' : '选择凭证文件'}
                                </Button>
                            </label>
                            {formData.transferVoucher && (
                                <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Button
                                        variant="text"
                                        size="small"
                                        onClick={handlePreview}
                                    >
                                        预览
                                    </Button>
                                    <Box sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
                                        {formData.transferVoucher}
                                    </Box>
                                </Box>
                            )}
                        </Box>
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                        <InputField
                            label="备注"
                            name="remark"
                            value={formData.remark}
                            onChange={handleInputChange}
                            multiline
                            rows={4}
                            fullWidth
                            inputProps={{
                                maxLength: 500
                            }}
                            helperText={`${formData.remark.length}/500`}
                            FormHelperTextProps={{
                                style: { textAlign: 'right' }
                            }}
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">取消</Button>
                    <Button onClick={handleSubmit} color="primary">保存</Button>
                </DialogActions>
            </Dialog>
            {/* 预览对话框保持不变 */}
            <Dialog
                open={previewOpen}
                onClose={handleClosePreview}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>凭证预览</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <img
                            src={previewImageUrl || ''}
                            alt="凭证预览"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '70vh',
                                objectFit: 'contain'
                            }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClosePreview}>关闭</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};